import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LinearGraph from '../../../components/LinearGraph/LinearGraph';
import NoData from '../../../components/NoData/NoData';
import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import { useStatistics } from '../../../hooks/useStatistics';

function MonthlyTabletVisitsPerCollection() {

  const { t } = useTranslation();

  const [chartData, setChartData] = useState<any[]>([]);
  const [labels, setLabels] = useState<string[]>([]);
  const data = useStatistics('total-visits');

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      const yearLabels = Object.keys(data["2021 Collection"]).sort();
      setLabels(yearLabels);
      const collections = Object.keys(data);
      const lineData = collections.map((collection, index) => {
        const values = Object.entries(data[collection]).map(([, value]) => value ?? 0).map(n => n as number);
        const backgroundColor = `rgba(75, 192, 192, 0.${index + 2})`;
        return {
          label: collection,
          data: values,
          backgroundColor,
          borderColor: backgroundColor,
          borderWidth: 1,
        };
      });
      setChartData(lineData);
    }
  }, [data]);

  return (
    <>
      <SectionTitle text={t("stats.visits_x_collection")} />
      {chartData.length > 0 ? (
        <LinearGraph title="Collections" xLabels={labels} dataSets={chartData} />
      ) : (
        <NoData message={t("global.empty_results")} />
      )}
    </>
  );
}

export default MonthlyTabletVisitsPerCollection;
